import styled from 'styled-components'
import { pxToRem } from 'styles/functions'

export const SCTopBarContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: auto;
  background-color: rgba(35, 35, 35, 0.75);
  display: flex;
  align-items: stretch;
  padding: ${pxToRem(8)} ${pxToRem(10)};
  z-index: 11;

  @media (min-width: 768px) and (orientation: landscape) {
    width: calc(100% - ${pxToRem(91)});
  }
`

export const SCTopBarLabelWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;
  @media (min-width: 768px) and (orientation: landscape) {
    justify-content: center;
  }
`

export const SCTopBarLabel = styled.h2`
  font-weight: 600;
  color: white;
  font-size: ${pxToRem(18)};
  font-family: ${({ theme }) => theme.title_font || `'Nunito', sans-serif`};
  margin: 0;

  @media (min-width: 768px) and (orientation: landscape) {
    text-align: center;
    font-size: ${pxToRem(24)};
  }
  @media (min-width: 768px) and (orientation: portrait) {
    font-size: ${pxToRem(24)};
  }
`
